import { TaxListDetailReportDto, TaxListDetailItemDto } from './TaxListDetailReportDto';
import { TaxListDetailItem, TaxListDetailReport } from 'model/TaxListReport';

function mapItem(item: TaxListDetailItemDto): TaxListDetailItem {
    const invoiceId = Number(item.invoice_id);
    const marketplaceId = Number(item.marketplace_id);

    return {
        invoiceId: Number.isFinite(invoiceId) && invoiceId > 0 ? invoiceId : undefined,
        invoiceNumber: String(item.invoice_number),
        marketplaceId: Number.isFinite(marketplaceId) && marketplaceId > 0 ? marketplaceId : undefined,
        saleDate: item.sale_date,
        clientName: item.client_name,
        category: item.category,
        type: item.type,
        item: item.item,
        quantity: item.quantity,
        paymentMethod: item.payment_method,
        taxName: item.tax_name,
        taxRate: item.tax_rate,
        netSales: item.net_sales,
        taxOnNetSales: item.tax_on_net_sales
    };
}

export const convertToTaxListDetailReport = (dto: TaxListDetailReportDto): TaxListDetailReport => {
    if (!dto || typeof dto !== 'object') {
        return {
            range: { start: '', end: '' },
            meta: { page: 1, perPage: 10, totalCount: 0, totalPages: 1 },
            items: []
        };
    }
    const range = dto.range ?? { start: '', end: '' };
    const rows = Array.isArray(dto.rows) ? dto.rows : [];
    return {
        range: { start: range.start, end: range.end },
        meta: {
            page: Number(dto?.meta?.page ?? 1),
            perPage: Number(dto?.meta?.per_page ?? 10),
            totalCount: Number(dto?.meta?.total_count ?? 0),
            totalPages: Number(dto?.meta?.total_pages ?? 0)
        },
        items: rows.map(mapItem)
    };
};
